/**
 * @generated SignedSource<<ebb1fbf47d4719bad13771f2800b5f8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type number_nativeIssueTable_NumberInlineEditCell_fieldRef$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "number_nativeIssueTable_NumberInlineEditCell_fieldRef";
};
export type number_nativeIssueTable_NumberInlineEditCell_fieldRef$key = {
  readonly " $data"?: number_nativeIssueTable_NumberInlineEditCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"number_nativeIssueTable_NumberInlineEditCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "number_nativeIssueTable_NumberInlineEditCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "number_issueFieldNumberInlineEditFull_NumberInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "8c280da2215ac59fe486945cc9e551a9";

export default node;
